import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/hooks";
import { destroyServerPlan } from "src/actions/mine_craft/serverPlansActions";
import { setEditId, ServerPlanInterface } from "src/store/mine_craft/serverPlansSlice";
import usePermissions from "src/hooks/usePermissions";
import { planFeatures } from "./format";

import { ButtonDestroy, ButtonEdit } from "src/componets/Buttons";
import { CheckOutlined } from "@ant-design/icons";
import { Space, Tag } from "antd";

import './planCard.scss';

interface propsInterface {
  plan: ServerPlanInterface;
  // Off in the server form's plan reference popup, which only shows
  // what each plan gives you.
  showActions?: boolean;
}

const _Card = ({ plan, showActions = true }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  // Reload after the delete: the plan's servers keep running, but their
  // rows now point at a plan that no longer exists.
  function onClickDestroy(id: number) {
    dispatch(destroyServerPlan(id)).then(() => navigate(0));
  }

  return (
    <div className={'v-plan-card' + (plan.featured ? ' v-plan-card--featured' : '')}>
      <div className='v-plan-card__head'>
        {plan.featured
          ? <span className='v-plan-card__badge'>BEST VALUE</span>
          : <span className='v-plan-card__badge v-plan-card__badge--empty' />
        }
        <code className='v-plan-card__slug'>{plan.slug}</code>
      </div>

      <h4 className='v-plan-card__title'>{plan.title}</h4>
      <p className='v-plan-card__description'>{plan.description || '—'}</p>

      <div className='v-plan-card__price'>
        {plan.coins}
        <small> c_coins / month</small>
      </div>

      {plan.max_per_user &&
        <Tag className='v-mb-10'>{plan.max_per_user} per user</Tag>
      }

      <ul className='v-plan-card__features'>
        {planFeatures(plan).map((feature, index) => (
          <li key={`${plan.id}-feature-${index}`}>
            <CheckOutlined /> {feature}
          </li>
        ))}
      </ul>

      <div className='v-plan-card__foot'>
        {plan.published
          ? <Tag color='success'>Published</Tag>
          : <Tag color='default'>Draft</Tag>
        }

        {showActions && write_minecraft &&
          <Space size='middle'>
            <ButtonEdit onClick={() => onClickEdit(plan.id)} />
            <ButtonDestroy onClick={() => onClickDestroy(plan.id)} />
          </Space>
        }
      </div>
    </div>
  )
}

export default _Card;
